import { CrossSellingContextType } from 'domains/crossSelling/CrossSelling.types';
import { useCrossSellingModuleDisplayed } from './useCrossSellingModuleDisplayed';

interface CrossSellingModuleDisplayedTrackerProps {
  mainReferenceNumber: string;
  mainReferenceFamilyCode?: string;
  vin?: string;
  mainReferenceSegmentMarketing?: string;
  contextType: CrossSellingContextType;
  location: 'product' | 'catalog';
  numberOfItemsInModule: number;
}

const CrossSellingModuleDisplayedTracker = ({
  mainReferenceNumber,
  mainReferenceFamilyCode,
  vin,
  mainReferenceSegmentMarketing,
  contextType,
  location,
  numberOfItemsInModule,
}: CrossSellingModuleDisplayedTrackerProps): React.JSX.Element | null => {
  useCrossSellingModuleDisplayed(
    mainReferenceNumber,
    mainReferenceFamilyCode,
    vin,
    mainReferenceSegmentMarketing,
    contextType,
    location,
    numberOfItemsInModule,
  );

  return null;
};

export default CrossSellingModuleDisplayedTracker;
